export default Object.freeze({
  FACET_SORT_ORDER_ASCENDING: 1,
  FACET_SORT_ORDER_DESCENDING: 2,
  FACET_SORT_TYPE_VALUES: 1,
  FACET_SORT_TYPE_HITS: 2
})
